import SEO from "components/seo";
import ShopContainer from "containers/shops/shopsPage";
import SettingsContainer from "containers/settings/settings";

export default function Shops() {
  return (
    <>
      <SEO />
      <SettingsContainer>
        <ShopContainer />
      </SettingsContainer>
    </>
  );
}
